const zh = {
  common: {
    facts: "关键数据",
    why: "为什么选择 Hotel Ciutat Martorell",
    related: "您可能还感兴趣",
    quoteEyebrow: "告诉我们您的婚礼构想",
  },
  nearSeat: {
    seoTitle: "马托雷利 SEAT-CUPRA 附近酒店 · 距工厂 5 分钟",
    seoDesc: "四星级酒店，距 SEAT-CUPRA 工厂及马托雷利工业园区仅 5 分钟。企业协议价、光纤 WiFi、停车场、餐厅，火车站距酒店 100 米。",
    eyebrow: "SEAT-CUPRA 商务访问酒店",
    title: ["距 SEAT-CUPRA 马托雷利工厂", "仅 5 分钟的酒店"],
    intro: "供应商、工程师、培训师和项目团队选择入住我们酒店，因为工厂和马托雷利工业园区近在咫尺，前往巴塞罗那的火车站距酒店仅 100 米。",
    facts: [
      { k: "SEAT-CUPRA 工厂", v: "驾车 5 分钟" },
      { k: "Renfe 与 FGC 车站", v: "100 米" },
      { k: "巴塞罗那", v: "30 分钟" },
      { k: "埃尔普拉特机场", v: "25 分钟" },
    ],
    sections: [
      { h: "为商务住宿而设计", p: "21 m² 客房配有书桌、免费光纤 WiFi 和空调。自助早餐 06:30 至 10:30 供应，确保准时赶上早班；24 小时前台方便深夜抵达；Business Corner 可打印文件或完成报告。" },
      { h: "企业协议价与集中开票", p: "对于定期到访工厂的企业，我们提供协议价格、集中开票以及团队预订的快捷处理。请告知大致住宿夜数，我们将为您准备方案。" },
      { h: "紧邻工厂的会议与培训", p: "三间采光良好的会议室，面积 35 至 220 m²，适合供应商培训、项目启动会或审计，配备投影仪、光纤网络和茶歇服务。My Bar 餐厅周一至周五提供商务套餐，适合工作午餐。" },
    ],
    why: [
      "驾车 5 分钟即达 SEAT-CUPRA 工厂及马托雷利工业园区",
      "酒店内设私人停车场（需额外付费）",
      "所有客房均配免费光纤 WiFi 与书桌",
      "早餐 06:30 开始，前台 24 小时服务",
      "企业协议价并支持集中开票",
    ],
    faqTitle: "关于入住 SEAT-CUPRA 附近",
    cta: { title: "直接预订或申请企业价", text: "在官方网站预订享最优价格保证，或为您的团队申请企业协议价。", secondary: "企业价格", secondaryTo: "corporate" },
    related: [
      { to: "corporate", label: "商务酒店" },
      { to: "meetingRooms", label: "会议室" },
      { to: "blogPost", params: { slug: "donde-alojarse-si-visitas-martorell-por-trabajo" }, label: "到马托雷利出差住哪里" },
    ],
  },
  nearMontserrat: {
    seoTitle: "蒙特塞拉特附近酒店 · 距修道院 20 分钟",
    seoDesc: "马托雷利四星级酒店，驾车 20 分钟即达蒙特塞拉特，FGC 火车站距酒店 100 米可换乘齿轨列车。游览修道院与巴塞罗那的舒适据点。",
    eyebrow: "游览蒙特塞拉特的理想酒店",
    title: ["蒙特塞拉特 20 分钟，", "巴塞罗那 30 分钟"],
    intro: "马托雷利是完美的中间点：上午游览蒙特塞拉特修道院与群山，下午前往巴塞罗那。夜晚则回到安静的客房，享用餐厅美食，停车无忧。",
    facts: [
      { k: "蒙特塞拉特修道院", v: "驾车 20 分钟" },
      { k: "FGC 火车换乘齿轨列车", v: "距酒店 100 米" },
      { k: "巴塞罗那", v: "30 分钟" },
      { k: "埃尔普拉特机场", v: "25 分钟" },
    ],
    sections: [
      { h: "从酒店前往蒙特塞拉特", p: "驾车 20 分钟即可抵达修道院或莫尼斯特罗尔的齿轨列车停车场。乘坐公共交通：FGC 车站距酒店 100 米，乘 R5 线至 Monistrol de Montserrat 换乘齿轨列车上山，或至 Montserrat-Aeri 换乘缆车。" },
      { h: "白天登山，夜晚安眠", p: "参观完大教堂、聆听 Escolania 童声合唱团或徒步至 Sant Jeroni 后，回到 21 m² 的客房，享受空调、淋浴浴室和光纤 WiFi。晚餐可在 My Bar 餐厅品尝地中海市场料理与佩内德斯葡萄酒。" },
      { h: "蒙特塞拉特与巴塞罗那一次游览", p: "从 Renfe 和 FGC 车站出发，约 30 分钟即达巴塞罗那。您可以一天游览蒙特塞拉特，一天游览城市，无需更换酒店，也无需为市中心停车烦恼。" },
    ],
    why: [
      "驾车 20 分钟即达蒙特塞拉特修道院",
      "FGC 车站距酒店 100 米，可换乘齿轨列车与缆车",
      "私人停车场，泊车后乘火车出行",
      "My Bar 餐厅供应地中海料理与佩内德斯葡萄酒",
      "自助早餐 06:30 至 10:30，方便早起登山",
    ],
    faqTitle: "关于从酒店游览蒙特塞拉特",
    cta: { title: "预订您的蒙特塞拉特之旅据点", text: "在官方网站直接预订享最优价格保证。团体出行？欢迎向我们索取方案。", secondary: "如何抵达酒店", secondaryTo: "location" },
    related: [
      { to: "blogPost", params: { slug: "como-llegar-a-montserrat-desde-martorell" }, label: "如何从马托雷利前往蒙特塞拉特" },
      { to: "location", label: "位置与交通" },
      { to: "blogPost", params: { slug: "que-visitar-cerca-de-martorell" }, label: "马托雷利周边景点" },
    ],
  },
  parkingBarcelona: {
    seoTitle: "巴塞罗那附近带停车场酒店 · 乘火车 30 分钟",
    seoDesc: "马托雷利四星级酒店，设私人停车场，距巴塞罗那 30 分钟。泊好车后从 100 米外的车站乘 Renfe 或 FGC 进城。官网直接预订。",
    eyebrow: "带停车场的酒店",
    title: ["泊好车，", "30 分钟到巴塞罗那"],
    intro: "如果您自驾前往巴塞罗那，住在市中心之外更安心、更简单：酒店设有私人停车场，门外 100 米即是直达市区的火车。",
    facts: [
      { k: "私人停车场", v: "位于酒店内" },
      { k: "Renfe 与 FGC 车站", v: "100 米" },
      { k: "巴塞罗那市中心", v: "30 分钟" },
      { k: "埃尔普拉特机场", v: "25 分钟" },
    ],
    sections: [
      { h: "酒店内的私人停车场", p: "为住店客人提供私人停车位（需额外付费），无需四处找车位，也不必支付巴塞罗那市中心的高昂停车费。随时进出，爱车就在客房几步之遥。" },
      { h: "乘火车进巴塞罗那，远离拥堵", p: "Renfe（Rodalies 近郊铁路）与 FGC 车站距酒店 100 米，约 30 分钟即达市中心；返程时爱车已在等候。若想游览整个省份，A-2 与 AP-7 高速公路就在旁边。" },
      { h: "设施齐全的度假酒店", p: "92 间 21 m² 客房配光纤 WiFi，设有 My Bar 餐厅、健身房，自助早餐 06:30 至 10:30。非常适合自驾游览巴塞罗那或蒙特塞拉特的家庭与情侣。" },
    ],
    why: [
      "酒店内为住客提供私人停车场",
      "距前往巴塞罗那的火车站 100 米：Renfe 与 FGC",
      "距巴塞罗那 30 分钟，距机场 25 分钟",
      "21 m² 大床房与双床房，配光纤 WiFi",
      "餐厅、健身房与 24 小时前台",
    ],
    faqTitle: "关于停车与前往巴塞罗那",
    cta: { title: "预订含停车场客房，告别停车烦恼", text: "在官方网站直接预订享最优价格保证，并告知我们您是否自驾前来。", secondary: "酒店服务", secondaryTo: "services" },
    related: [
      { to: "blogPost", params: { slug: "como-ir-de-martorell-a-barcelona" }, label: "如何从马托雷利前往巴塞罗那" },
      { to: "services", label: "酒店服务" },
      { to: "blogPost", params: { slug: "transportes-entre-martorell-y-barcelona" }, label: "马托雷利与巴塞罗那之间的交通" },
    ],
  },
  weddingsBaix: {
    seoTitle: "巴伊什略夫雷加特婚礼酒店 · 马托雷利",
    seoDesc: "在马托雷利举办婚礼：宴会厅可容纳 150 位宾客，露台鸡尾酒会可容纳 200 人，提供试菜套餐、新婚客房及宾客优惠房价。",
    eyebrow: "巴伊什略夫雷加特的婚礼",
    title: ["您在巴伊什略夫雷加特的婚礼，", "一切尽在同一屋檐下"],
    intro: "露台鸡尾酒会、220 m² 采光宴会厅中的婚宴、酒店自有的地中海厨房，以及 92 间客房让宾客无需驾车返家。距巴塞罗那 30 分钟，与整个地区交通便利。",
    facts: [
      { k: "婚宴", v: "最多 150 位宾客" },
      { k: "鸡尾酒会", v: "最多 200 人" },
      { k: "宴会厅", v: "220 m²，自然采光" },
      { k: "客房", v: "92 间供宾客入住" },
    ],
    sections: [
      { h: "空间：露台、宴会厅与客房", p: "露台上的迎宾鸡尾酒会，220 m² 可分隔宴会厅中的婚宴，结束后为新人提供免费新婚客房，并为留宿的宾客提供特惠房价。" },
      { h: "自有厨房与试菜套餐", p: "我们的厨师团队以当季地中海食材与佩内德斯葡萄酒定制婚宴菜单。大喜之日前，我们会安排试菜，与新人一同敲定每一道菜。" },
      { h: "从第一杯咖啡开始的专属统筹", p: "48 小时内提供固定报价，绝无意外。专属统筹负责时间安排、供应商、DJ 及可选的畅饮酒吧，新人只需尽情享受。" },
    ],
    why: [
      "方便来自巴塞罗那及整个地区的宾客：驾车 30 分钟，火车站距酒店 100 米",
      "220 m² 自然采光宴会厅与举办鸡尾酒会的露台",
      "免费新婚客房及宾客特惠房价",
      "婚前试菜套餐与自有地中海厨房",
      "专属统筹与 48 小时内固定报价",
    ],
    faqTitle: "关于在酒店举办婚礼",
    cta: { title: "告诉我们您理想中的婚礼", text: "请告知大致日期、宾客人数及您的构想，我们将在 48 小时内回复方案。" },
    related: [
      { to: "weddings", label: "酒店婚礼" },
      { to: "events", label: "活动与庆典" },
      { to: "meetingRoomDetail", params: { slug: "salon-montserrat" }, label: "宴会厅" },
    ],
  },
};

export default zh;
